export default __webpack_public_path__ + "static/media/magnifier.6e219260.png";